module.exports = __webpack_public_path__ + "static/media/hp-login-banner-tablet-@1x.936d7912.jpg";